import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Expert from "./sections/Expert";
import Mission from "./sections/Mission";
import Excellence from "./sections/Excellence";
import Biography from "./sections/Biography";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Expert />
      <Biography />
      <Mission />
      <Excellence />
      <Footer />
    </div>;
}